import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerFscQuickInfo extends Layout {
    sourceCustomerFsc: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
